export default __webpack_public_path__ + "static/media/timerIco.fd81c67c.svg";